import React from 'react'

/** Material UI **/
import { Container } from '@mui/material'

const Dashboard = (props) => {
  return (
    <div>
      <Container>
        {/* TODO DASHBOARD */}
        <p>DASHBOARD</p>
      </Container>
    </div>
  )
}

export default Dashboard
